var render, staticRenderFns
import script from "./SearchMenu.vue?vue&type=script&lang=js&"
export * from "./SearchMenu.vue?vue&type=script&lang=js&"
import style0 from "./SearchMenu.vue?vue&type=style&index=0&id=10d4b794&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d4b794')) {
      api.createRecord('10d4b794', component.options)
    } else {
      api.reload('10d4b794', component.options)
    }
    
  }
}
component.options.__file = "src/layout/components/SearchMenu.vue"
export default component.exports